class NoResponseError extends Error {}

export default NoResponseError
